//
//
//
//
//
//
//
//
//
//

import errorImg from '@/assets/img/error.png'

export default {
  props: {
    src: {
      type: String,
      default: '',
    },
  },

  data () {
    return { defaultImg: `this.src="${errorImg}"` }
  },
}
